import React from "react";
import { LENDERS } from "@/lib/constants";

export const LenderMarquee = () => {
    const doubled = [...LENDERS, ...LENDERS];
    return (
        <section data-testid="lender-marquee" className="bg-background border-y border-border">
            <div className="container-prose py-16">
                <div className="text-center mb-10">
                    <div className="overline">Our lender panel</div>
                    <h2 className="mt-3 font-serif text-3xl sm:text-4xl text-[#1A362B] tracking-tight">
                        Access to 60+ Australian lenders.
                    </h2>
                </div>
            </div>
            <div className="overflow-hidden relative">
                <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
                <div className="lender-track py-6">
                    {doubled.map((l, i) => (
                        <div
                            key={`${l}-${i}`}
                            data-testid={`lender-${i}`}
                            className="px-10 py-4 mx-3 border border-border rounded-sm bg-white text-[#1A362B] font-serif text-xl tracking-tight whitespace-nowrap shrink-0"
                        >
                            {l}
                        </div>
                    ))}
                </div>
            </div>
            <div className="container-prose pt-12 pb-4 text-center">
                <p className="text-sm text-[#1C1C1C]/60">+ many more — including non-bank, specialist and private lenders.</p>
            </div>
        </section>
    );
};

export default LenderMarquee;
